import { Dispatch } from 'redux';
import { requestHandler } from '../../utils/generalUtils';
import { SetSignUpFlowTask, UpdateTask } from './SignUpFlowActions';
import { IDENTIFIERS, SignUpFlowActionTypes, Task } from './types';

export const completeTaskOperation = async (
    dispatch: Dispatch<SignUpFlowActionTypes>,
    data: { onboardingTaskId: number; completed: boolean },
    type: IDENTIFIERS,
) => {
    dispatch(UpdateTask({ type, completed: data.completed }));
    const response = await requestHandler('PUT', '/api/onboarding-tasks', { ...data });
    if (response.status === 200 || response.status === 204 || response.success) {
        fetchOnboardingTasksOperation(dispatch);
    }
    return false;
};

export const fetchOnboardingTasksOperation = async (dispatch: Dispatch<SignUpFlowActionTypes>) => {
    const res = await requestHandler<Task[]>(
        'GET',
        '/api/onboarding-tasks?select=id,title,description,path,identifier,sequence',
    );
    if (res.success) {
        dispatch(SetSignUpFlowTask(res.payload));
    }
};
